import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

import type { SeparatorProps } from './types'

export const Separator = styled(Box)<SeparatorProps>`
  ${({ spacing }) => css`
    height: ${spacing}px;
  `}
`
